// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import Icon from 'components/common/Icon'
import { Dropdown } from 'components/common/Dropdown/Dropdown'

export const KebabAnchor = React.forwardRef(
  ({ className, isActive, ...props }, ref) => (
    <span
      className={cx('Action small', { active: isActive })}
      ref={ref}
      {...props}
    >
      <span className={'icon'}>
        <Icon name="kebab" />
      </span>
    </span>
  ),
)

const KebabAction = ({ children, ...props }) => (
  <Dropdown Anchor={KebabAnchor} {...props}>
    <div className="kebabmenu">{children}</div>
  </Dropdown>
)

export default KebabAction
